import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import useRating from './useRating'
import clearProps from '../../utils/clearProps'

export default function RatingStars(props) {
  const { rate, readOnly, children } = props

  const { config, rateReadOnly, renderTotalRating, getType } = useRating()
  const [currentRate, setcurrentRate] = React.useState(rate)

  const rest = clearProps(props)

  const handleKeyPress = (e, ratingValue, type) => {
    if (e.charCode === 32 || e.charCode === 13) {
      handleStarsValue(ratingValue, type)
    }
  }
  const firstStar = (ratingValue, type) => {
    if (type !== 'avaliacao-vazia' || type !== 'meia-avaliacao') {
      setcurrentRate(1)
    }
    if (type !== 'avaliacao-vazia') {
      setcurrentRate(0)
    }
  }

  const middleStar = (ratingValue, type) => {
    setcurrentRate(ratingValue, readOnly)
  }
  const lastStar = (ratingValue, type) => {
    if (type !== 'avaliacao-vazia' || type !== 'meia-avaliacao') {
      setcurrentRate(5)
    }
    if (type === 'avaliacao') {
      setcurrentRate(0)
    }
  }

  const handleStarsValue = (ratingValue, type) => {
    if (ratingValue !== 1 && ratingValue !== 5) middleStar(ratingValue, type)
    if (ratingValue === 1) { firstStar(ratingValue, type) }
    if (ratingValue === 5) lastStar(ratingValue, type)
  }

  const renderStars = (readOnly, rate) => {
    const stars = Array.from({ length: 5 }).map((_, index) => {
      const ratingValue = index + 1
      const type = getType(currentRate, index)

      return (
        <span
          key={ratingValue}
          tabIndex={0}
          className={'mdn-Icon-' + type + ' mdn-Icon--sm mdn-Rating Stars-star'}
          key={ratingValue}
          aria-label={type}
          onKeyPress={(e) => handleKeyPress(e, ratingValue, type)}
          onClick={() => handleStarsValue(ratingValue, type)}

        />
      )
    })
    return stars
  }

  return (
    <div
      {...rest}
      className={resolveProps(props, config, 'RatingStars')}
      data-mdn-rate={currentRate}
      tabIndex={0}
    >
      {rateReadOnly(currentRate, readOnly)}
      <label
        className="mdn-RatingStars-check"
        aria-label={`${currentRate} de ${config.starsLength} avaliações`}
      >
        {renderStars(readOnly, currentRate)}
      </label>
      {renderTotalRating(readOnly, children)}
    </div>
  )
}

RatingStars.propTypes = {
  children: PropTypes.node,
  rate: PropTypes.number,
  readOnly: PropTypes.bool,
  config: PropTypes.object
}
